
import { computed, defineComponent, PropType } from 'vue';
import { B2CFavoriteStoreTileModel } from '@/types/B2CcontentServerContract';
import StoreDetail from '@/b2c/shared/stores/ui/StoreDetail.vue';
import authStore from '@/shared/auth/auth.store';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';

export default defineComponent({
    name: 'B2CFavoriteStoreTile',
    components: { BlockMaxWidthHandler, StoreDetail },
    props: {
        content: {
            type: Object as PropType<B2CFavoriteStoreTileModel>,
            required: true,
        },
    },
    setup() {
        const labels = useBlockLabels();
        const storeId = computed(() => authStore.storeId);

        return {
            labels,
            storeId,
        };
    },
});
